<template>
  <div class="h-full w-full flex overflow-auto bg-white">
    <div
      class="w-56/100 bg-warp min-h-full relative flex flex-col justify-between"
    >
      <logo></logo>

      <!-- <img src="~@/assets/image/svg/login-bg.svg" class="-enter-x -mt-1/5" /> -->
      <img src="~@/assets/image/img/login-bg.png" class="-enter-x -mt-1/5" />

      <a-modal
        v-model:visible="visible"
        title="选择要登录的渠道"
        :footer="null"
        :destroy-on-close="true"
        :mask-closable="false"
        :width="900"
      >
        <div>
          <div class="font-normal">请选择要登录的渠道：</div>
          <div class="overflow-x-auto">
            <div class="flex pt-4">
              <Card
                v-for="item of talent"
                :key="item.tenantId"
                class="mr-5 w-40"
                :select="item.tenantId === tid"
                @click="onSelect(item)"
              >
                <div class="text-center">
                  <div
                    class="logoUrl"
                    :style="{ backgroundImage: `url(${item.thumbnail})` }"
                  ></div>
                  <div class="mt-2 truncate font-bold channel-name">
                    {{ item.channelName }}
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </a-modal>

      <copyRightFooter></copyRightFooter>
    </div>
    <div class="w-44/100 min-h-full flex flex-col justify-center">
      <div class="w-full enter-x w-92 ml-33 min-h-122">
        <div class="title mb-8">
          用户登录<span class="sub ml-2">USER LOGIN</span>
        </div>
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="account" tab="账号登录"
            ><a-form
              ref="accountFormRef"
              :model="ruleForm"
              name="account"
              autocomplete="off"
              @finish="onFinish"
              @finishFailed="onFinishFailed"
            >
              <a-form-item
                name="username"
                :rules="rules.username"
                class="enter-x"
              >
                <a-input
                  v-model:value="ruleForm.username"
                  size="large"
                  placeholder="请输入手机号"
                  ><template #prefix>
                    <UserOutlined :style="iconStyle" /> </template
                ></a-input>
              </a-form-item>

              <a-form-item
                name="password"
                :rules="rules.password"
                class="enter-x"
              >
                <a-input-password
                  v-model:value="ruleForm.password"
                  size="large"
                  placeholder="请输入登录密码"
                >
                  <template #prefix>
                    <LockOutlined :style="iconStyle" />
                  </template>
                </a-input-password>
              </a-form-item>

              <a-form-item name="code" :rules="rules.code" class="enter-x">
                <div class="flex">
                  <a-input
                    v-model:value.trim="ruleForm.code"
                    size="large"
                    placeholder="请输入右侧校验码"
                    ><template #prefix>
                      <code-outlined :style="iconStyle" /></template
                  ></a-input>
                  <div
                    class="ml-4 flex-none h-10 w-27 cursor-pointer"
                    @click="onRefreshCode"
                  >
                    <img :src="code.url" alt="" />
                  </div>
                </div>
              </a-form-item>

              <a-form-item name="remember" class="enter-x">
                <div class="flex justify-between items-center">
                  <a-checkbox v-model:checked="ruleForm.remember"
                    >记住密码</a-checkbox
                  >

                  <router-link
                    class="primary"
                    :to="{ name: 'RetrievePassword' }"
                    >忘记密码</router-link
                  >
                </div>
              </a-form-item>

              <a-form-item class="enter-x">
                <a-button
                  type="primary"
                  size="large"
                  block
                  html-type="submit"
                  :loading="loading"
                  >登录</a-button
                >
              </a-form-item>
              <a-form-item class="enter-x">
                <div class="text-center register">
                  还没有账号？<span
                    class="primary cursor-pointer"
                    @click="onRegister"
                    >注册一个>></span
                  >
                </div>
              </a-form-item>
            </a-form></a-tab-pane
          >
          <a-tab-pane key="phone" tab="手机号登录"
            ><a-form
              ref="phoneFormRef"
              :model="phoneForm"
              name="phone"
              autocomplete="off"
              @finish="onFinish"
              @finishFailed="onFinishFailed"
            >
              <a-form-item name="mobile" :rules="rules.mobile" class="enter-x">
                <a-input
                  v-model:value="phoneForm.mobile"
                  size="large"
                  placeholder="请输入手机号"
                  ><template #prefix>
                    <mobile-outlined :style="iconStyle" /> </template
                ></a-input>
              </a-form-item>

              <a-form-item name="code" :rules="rules.code" class="enter-x">
                <div class="flex">
                  <a-input
                    v-model:value.trim="phoneForm.code"
                    size="large"
                    placeholder="请输入右侧校验码"
                    ><template #prefix>
                      <code-outlined :style="iconStyle" /></template
                  ></a-input>
                  <div
                    class="ml-4 flex-none h-10 w-27 cursor-pointer"
                    @click="onRefreshCode"
                  >
                    <img :src="code.url" alt="" />
                  </div>
                </div>
              </a-form-item>

              <a-form-item
                name="verifyCode"
                :rules="rules.verifyCode"
                class="enter-x"
              >
                <div class="flex">
                  <a-input
                    v-model:value.trim="phoneForm.verifyCode"
                    size="large"
                    placeholder="请输入短信验证码"
                    ><template #prefix>
                      <security-scan-outlined :style="iconStyle" /> </template
                  ></a-input>
                  <a-button
                    size="large"
                    class="ml-4 flex-none"
                    style="width: 108px"
                    :disabled="time !== 0"
                    :loading="codeLoading"
                    @click="
                      onVerifyCode(
                        phoneForm.mobile,
                        code.code == phoneForm.code
                      )
                    "
                    >{{ time > 0 ? `${time}s后重试` : '点击获取' }}</a-button
                  >
                </div>
              </a-form-item>

              <a-form-item class="enter-x">
                <a-button
                  type="primary"
                  size="large"
                  block
                  html-type="submit"
                  :loading="loading"
                  >登录</a-button
                >
              </a-form-item>
              <a-form-item class="enter-x">
                <div class="text-center register">
                  还没有账号？<span
                    class="primary cursor-pointer"
                    @click="onRegister"
                    >注册一个>></span
                  >
                </div>
              </a-form-item>
            </a-form></a-tab-pane
          >
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, reactive, ref, toRaw } from 'vue';
import Card from '@/components/card/card.vue';
import { encode, decode } from 'js-base64';
import { useRouter, useRoute } from 'vue-router';
import {
  UserOutlined,
  LockOutlined,
  CodeOutlined,
  SecurityScanOutlined,
  MobileOutlined,
} from '@ant-design/icons-vue';
import {
  loginUsernamePasswordReq,
  loginSmsReq,
  loginSms,
  loginUsernamePassword,
  loginUsernamePasswordRes,
  IloginUsernamePasswordRestenantChannelInfoVOListInterFace,
  channelCheckChannel,
} from '@/api/login';
import { Rule } from 'ant-design-vue/lib/form';
import { FormInstance } from 'ant-design-vue';
import { clearStorage, getStorage, setStorage } from 'xag-ai-utils';
import logo from '@/components/logo.vue';
import copyRightFooter from '@/components/copy-right-footer.vue';
import { GVerify } from '@/utils/verify';
import {
  accessTokenName,
  prevStoreKey,
  prevStoreTid,
  selectedStoreKey,
  tenantTokenName,
} from '@/config';
import { useIamAuthStore } from '@/store/iam';
import { warning } from '@/utils/iam';
import { useHeaderStore } from '@/store/header';
import { Callbacks } from 'ant-design-vue/lib/form/interface';
import { verifyCode } from '@/hook/verify-code';
const verifyCodeUtils = new GVerify({
  type: 'number',
  width: 108,
  height: 40,
});
const headerStore = useHeaderStore();
const router = useRouter();
const route = useRoute();
const loading = ref(false);

const activeKey = ref('account');
const iconStyle = { color: '#1890FF' };
const codeInfo = verifyCodeUtils.refresh();
const code = reactive({
  url: codeInfo.url,
  code: codeInfo.code,
});

const { time, codeLoading, onVerifyCode, cancel } = verifyCode();

const storeKey = 'bauth';
const store = getStorage(storeKey);

const accountFormRef = ref<FormInstance>();
const phoneFormRef = ref<FormInstance>();
const iam = useIamAuthStore();

const visible = ref<boolean>(false);
const talent = ref<loginUsernamePasswordRes['tenantChannelInfoVOList']>([]);
const tid = ref<string>('');

let isEqualToPrev = false;
const ruleForm = reactive<
  loginUsernamePasswordReq & {
    code: string;
    remember: boolean;
  }
>({
  username: '',
  password: '',
  code: '',
  remember: false,
});

const phoneForm = reactive<
  loginSmsReq & {
    code: string;
  }
>({
  code: '',
  verifyCode: '',
  mobile: '',
});

const rules = reactive({
  username: [
    {
      required: true,
      message: '请输入账号',
    },
  ],

  mobile: [
    {
      required: true,
      message: '请输入手机',
    },
  ],

  verifyCode: [
    {
      required: true,
      message: '请输入短信验证码',
    },
  ],

  code: [
    {
      required: true,
      message: '请输入右侧校验码',
    },
    {
      validator: (_rule: Rule, value: string) => {
        const v = code.code.toLowerCase();
        const v_code = value.toLowerCase();
        if (value && v_code !== v) {
          return Promise.reject('请输入正确的校验码');
        } else {
          return Promise.resolve();
        }
      },
      trigger: 'blur',
    },
  ],

  password: [
    {
      required: true,
      message: '请输入密码',
    },
  ],
});

onMounted(() => {
  ruleForm.remember = store?.remember || false;
  ruleForm.username = store?.username || '';
  ruleForm.password = store?.password ? decode(store?.password) : '';
});

onBeforeUnmount(() => {
  cancel();
});

const onFinish = async (values: loginUsernamePasswordReq | loginSmsReq) => {
  loading.value = true;
  try {
    const params = toRaw(values);
    const isPhone = activeKey.value === 'phone';

    // 清楚菜单的缓存
    sessionStorage.removeItem(selectedStoreKey);

    clearStorage(tenantTokenName);
    clearStorage(accessTokenName);
    clearStorage('userInfoVO');
    iam.resetApp();
    headerStore.resetApp();

    const prevStore = getStorage(prevStoreKey);

    setStorage(prevStoreKey, {
      mobile: (params as loginSmsReq).mobile,
      username: (params as loginUsernamePasswordReq).username,
    });
    const account = isPhone
      ? (params as loginSmsReq).mobile
      : (params as loginUsernamePasswordReq).username;
    isEqualToPrev =
      prevStore && [prevStore.mobile, prevStore.username].includes(account);
    console.log(isEqualToPrev);

    if (!isPhone) {
      if (ruleForm.remember) {
        setStorage(storeKey, {
          ...params,
          password: encode((params as loginUsernamePasswordReq).password),
        });
      } else {
        clearStorage(storeKey);
      }
    }

    if (isPhone) {
      const data = await loginSms(params as loginSmsReq);

      // setStorage(accessTokenName, data?.userInfoVO?.xaToken);
      setStorage(accessTokenName, data?.userInfoVO?.xaToken);
      sessionStorage.setItem('accessTokenName', data?.userInfoVO?.xaToken);
      setStorage('userInfoVO', data?.userInfoVO);
      talent.value = data.tenantChannelInfoVOList;
    } else {
      const data = await loginUsernamePassword(
        params as loginUsernamePasswordReq
      );

      setStorage(accessTokenName, data?.userInfoVO.xaToken);
      sessionStorage.setItem('accessTokenName', data?.userInfoVO?.xaToken);
      setStorage('userInfoVO', data.userInfoVO);
      talent.value = data.tenantChannelInfoVOList;
    }

    onRefreshCode();
    phoneForm.code = ruleForm.code = '';
    loading.value = false;

    if (!talent.value || !talent.value.length) {
      return warning();
    }

    if (talent.value?.length > 1) {
      visible.value = true;
    } else {
      onSelect(talent.value[0]);
    }
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

const onFinishFailed: Callbacks['onFinishFailed'] = (v) => {
  console.log(v.errorFields);
  const hasCodeError = v.errorFields.find((i) => i.name.includes('code'));
  if (hasCodeError) {
    onRefreshCode();
  }
};

const onJumpNext = () => {
  const redirect = route.query?.redirect;
  if (redirect && redirect != '/' && redirect != '/login' && isEqualToPrev) {
    router.replace(redirect as string);
  } else {
    const next = iam.getFirstUrl();
    if (!next) {
      warning();
    } else {
      router.push(next);
    }
  }
};

const onRegister = () => {
  router.push({ name: 'Register' });
};

// 刷新验证码
const onRefreshCode = () => {
  const codeInfo = verifyCodeUtils.refresh();
  code.code = codeInfo.code;
  code.url = codeInfo.url;
};

async function onSelect(
  item: IloginUsernamePasswordRestenantChannelInfoVOListInterFace
) {
  if (loading.value) {
    return;
  }
  loading.value = true;
  tid.value = item.tenantId;
  visible.value = false;

  const prevTid = localStorage.getItem(prevStoreTid);
  setStorage(prevStoreTid, item.tenantId);
  console.log(prevTid, item.tenantId);
  isEqualToPrev = isEqualToPrev && prevTid == item.tenantId;
  console.log(isEqualToPrev);

  setStorage(tenantTokenName, tid.value);
  sessionStorage.setItem(tenantTokenName, tid.value);
  await channelCheckChannel({
    channelId: item.channelId,
    tenantId: item.tenantId,
  })
    .then(() => {
      return iam.fetchMenus();
    })
    .finally(() => (loading.value = false));

  onJumpNext();
}
</script>

<style lang="scss" scoped>
.title {
  color: #000;
  font-weight: 600;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
}

.sub {
  color: rgb(0 0 0 / 65%);
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}

.register {
  color: rgb(0 0 0 / 65%);
  font-weight: 400;
  font-size: 14px;
  // font-family: 'PingFang SC';
  font-style: normal;
  line-height: 22px;
}

.logoUrl {
  width: 134px;
  height: 120px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.channel-name {
  font-size: 14px;
}
</style>
